// Dynamic styles based on theme - to be used with useThemedStyles.
export const createChecklistFormViewStyles = ({ ui: { colors, radius, space, touch, type } }) => ({
	section: {
		gap: space.sm,
	},
	// A submitted checklist: saved answers greyed out.
	readOnly: {
		opacity: 0.75,
	},
	rowItem: {
		gap: 10,
		minHeight: 64,
		justifyContent: 'center',
		paddingHorizontal: 14,
		paddingVertical: 10,
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		backgroundColor: colors.raised,
	},
	blockItem: {
		gap: 6,
		paddingVertical: space.xs,
	},
	// Required or invalid items the driver still has to fix.
	itemError: {
		borderWidth: 1,
		borderColor: colors.danger,
		borderRadius: radius.card,
		paddingHorizontal: 14,
		paddingVertical: 10,
	},
	rowTop: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.md,
	},
	stackedControl: {
		alignItems: 'flex-start',
	},
	choices: {
		alignSelf: 'stretch',
		gap: space.sm,
	},
	choice: {
		minHeight: touch.min,
		justifyContent: 'center',
		paddingHorizontal: 14,
		paddingVertical: space.sm,
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
	},
	choiceText: {
		...type.bodySmallStrong,
		color: colors.text,
	},
	question: {
		flex: 1,
		gap: 3,
	},
	questionLabel: {
		...type.rowTitle,
		color: colors.text,
	},
	blockLabel: {
		...type.rowTitleSemibold,
		color: colors.text,
	},
	description: {
		...type.caption,
		color: colors.textSecondary,
	},
	numberInput: {
		width: 112,
		marginBottom: 0,
	},
	multilineInput: {
		minHeight: 96,
		textAlignVertical: 'top',
		marginBottom: 0,
	},
	// Submitted text answers and comments: the text box look, growing with the text.
	readOnlyField: {
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
		paddingHorizontal: 14,
		paddingVertical: 12,
	},
	readOnlyFieldText: {
		...type.rowText,
		color: colors.text,
	},
	commentInput: {
		minHeight: 72,
		textAlignVertical: 'top',
		marginBottom: 0,
	},
	pills: {
		flexDirection: 'row',
		gap: space.sm,
	},
	pill: {
		flex: 1,
		minHeight: touch.compactButton,
		borderRadius: radius.pill,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
		alignItems: 'center',
		justifyContent: 'center',
	},
	pillSelected: {
		borderColor: colors.primary,
		backgroundColor: colors.primary,
	},
	pressed: {
		opacity: 0.85,
	},
	pillText: {
		...type.bodyStrong,
		color: colors.text,
	},
	pillTextSelected: {
		color: colors.onPrimary,
	},
	optionList: {
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		backgroundColor: colors.raised,
		paddingHorizontal: 14,
	},
	optionRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.md,
		minHeight: touch.row,
	},
	optionText: {
		...type.rowText,
		color: colors.text,
		flex: 1,
	},
	photoRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
	},
	photo: {
		alignItems: 'center',
		gap: space.xs,
	},
	photoThumbnail: {
		width: 72,
		height: 72,
		borderRadius: radius.chip,
		backgroundColor: colors.raised,
	},
	photoRemoveHint: {
		...type.caption,
		color: colors.textSecondary,
	},
	errorText: {
		...type.secondaryStrong,
		color: colors.danger,
	},
	signOffCard: {
		gap: space.md,
		padding: 14,
		borderRadius: radius.card,
	},
	signOffStatus: {
		flexDirection: 'row',
		alignItems: 'flex-start',
		gap: space.md,
	},
	// One title line high, so the icon centres on the first line, not on the whole card.
	signOffIcon: {
		height: type.rowTitle.lineHeight,
		justifyContent: 'center',
	},
});
